import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  setting: {
    padding: '24px 40px 24px 40px',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.common.white
  },
  settingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  settingDetailMain: {
    color: palette.shades[700],
    fontSize: '18px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    fontFamily: palette.fontFamilies.poppins,
    '& span': {
      color: palette.common.black,
      marginLeft: '4px'
    },
    '& .MuiSvgIcon-root': {
      marginRight: '20px'
    }
  },
  settingDetailCustom: {
    color: palette.shades[600],
    fontWeight: '600',
    fontSize: '13px',
    paddingLeft: '44px',
    fontFamily: palette.fontFamilies.poppins
  },
  info: {
    zIndex: '1',
    position: 'relative',
    marginBottom: '-1px',
    backgroundColor: palette.shades[200],
    padding: '12px 12px 0 12px'
  },
  feeRelink: {
    display: 'flex',
    padding: '12px 24px',
    backgroundColor: palette.warning.light,
    '&.relink': {
      backgroundColor: palette.info.light
    },
    '& .MuiSvgIcon-root': {
      marginRight: '5px'
    }
  },
  feeRelinkText: {
    display: 'flex'
  }
});
export default useStyles;